<template>
    <div class="user-info container">
        <div class="user-info-inner">
            <div class="user-info-text">
                <p>Ерөнхий мэдээлэл</p>
            </div>
            <div class="user-info-board">
                    <div class="user-info-item">
                        <p style="padding-top:15px;">Карт эзэмшигч</p>
                        <div class="user-info-name">
                            <p>Овог нэр:</p>
                            <p>{{user.lastName}} {{user.firstName}}</p>
                            <p>Картын дугаар:</p>
                            <p>{{user.cardId}}</p>
                        </div>
                    </div>
                     <div class="user-info-item">
                        <p style="padding-top:15px;">Картын мэдээлэл</p>
                        <div class="user-info-name">
                            <p>Картын хувь:</p>
                            <p v-if=" user.cardPercent  != null">{{user.cardPercent | percent}}</p>
                            <p>Бонус:</p>
                            <p v-if=" user.bonusBalance  != null">{{user.bonusBalance | pricewithindex}}</p>
                            <p>Койн:</p>
                            <p v-if=" user.embBalance  != null">{{user.embBalance | pricewithindex}}</p>
                            <p>U-POINT:</p>
                            <p v-if=" user.upointBalance  != null">{{user.upointBalance | pricewithindex}}</p>
                            <div v-if="isdvip">
                                <p>Ашиглах боломжтой оноо</p>
                                <p v-if=" user.dvipBalance  != null">{{user.dvipBalance | pricewithindex}}</p>
                                <p>Хуримтлагдаж байгаа оноо</p>
                                <p v-if=" user.dvipSavedBalance  != null">{{user.dvipSavedBalance | pricewithindex}}</p>
                            </div>
                            <p>сүүлийн 2 жилийн Худалдан авалтйн дүн:</p>
                            <p style="text-align:right;width:100%" v-if=" user.last2yearPurchase  != null">{{user.last2yearPurchase |  pricewithindexof}}</p>
                        </div>
                    </div>
                    <div class="user-info-item"  v-if="isdvip" v-for="item in user.partners" :key="item.cardId">
                        <p style="padding-top:15px;">Хамтран эзэмшигч</p>
                        <div class="user-info-name">
                            <p>Овог нэр:</p>
                            <p>{{item.firstName}} {{item.lastName}}</p>
                            <p>Картын дугаар:</p>
                            <p>{{item.cardId}}</p>
                            <p>Төлөв:</p>
                            <p>{{dvip(item)}}</p>
                        </div>
                    </div>
                   <div class="user-info-item"  v-if="partner" v-for="item in user.partners" :key="item.cardId">
                        <p style="padding-top:15px;">Хамтран эзэмшигч</p>
                        <div class="user-info-name">
                            <p>Овог нэр:</p>
                            <p v-if=" item.firstName  != null">{{item.firstName}} {{item.lastName}}</p>
                            <p>Картын дугаар:</p>
                            <p v-if=" item.cardId  != null">{{item.cardId}}</p>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/EventBus.js';
import { MobileUserInfo } from '@/mixins/MobileUserInfo'
    export default {
        mixins:[MobileUserInfo],
        data(){
            return{
                user : {},
                partner : false,
                nomin : true,
                isdvip:false
            }
        },
        methods:{
            dvip:(item) =>{
                return item.dvip == 'A' ? 'Бонус хасна' : 'Бонус нэмнэ хасна';
            },
            RedirectLogin(){
                EventBus.$emit('GLOBAL_ERROR','error');
            },
            hideMenu(){
                EventBus.$emit('MOBILE_MENU_HIDE');
            }
        },
        created(){
            this.hideMenu();
        }
    }
</script>

<style>
.content{
    background: #ededed;
}
.user-info{
    padding-top:20px;
    margin-top:50px;
}
.user-info-inner{
    padding-top:22px;
}
.user-info-text{
    margin:0;
    padding:0;
    width:100;
    height: auto;
    text-align: center;
}
.user-info-text p{
    margin:0;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #1660ab;
}
.user-info-board{
    margin-top:17px;
    width: 100%;
    border-radius: 10px;
    box-shadow: 0px 5px 5px 0 rgba(0, 0, 0, 0.05);
    background-color: #fff;
}
.user-info-item{
    padding-left:25px;
    padding-right: 30px;
    width:100%;
    height:auto;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #d8d8d8;
}
.user-info-item p{
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: #1660ab;
    text-transform: uppercase;
    margin:0;
}
.user-info-name{
    width:100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-bottom:30px;
}

.user-info-name p:nth-child(1),.user-info-name p:nth-child(3),.user-info-name p:nth-child(5),.user-info-name p:nth-child(7).user-info-name p:nth-child(9).user-info-name p:nth-child(11){
    width:40%;
    font-size: 10px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
}
.user-info-name p:nth-child(2),.user-info-name p:nth-child(4),.user-info-name p:nth-child(6),.user-info-name p:nth-child(8).user-info-name p:nth-child(10).user-info-name p:nth-child(12){
    width:60%;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: right;
    line-height: 2.77;
    letter-spacing: normal;
    color: #000000;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.user-info-name p:nth-child(11){
    width:40%;
    font-size: 10px!important;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgba(0, 0, 0, 0.5)!important;
    display: flex;
    align-items: center;
}
.user-info-name p:nth-child(12){
    width:60%;
    font-size: 13px!important;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.77;
    letter-spacing: normal;
    color: #000000;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.user-info-name p:nth-child(13){
    margin-top:15px;
    width:100%;
    font-size: 10px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
}
.user-info-name p:nth-child(14){
    font-size: 13px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.85;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
}
</style>
